import React from 'react'
import PropTypes from 'prop-types'
import { Provider, observer } from 'mobx-react'
import WidgetStore from './WidgetStore'
import ModalContainer from './ModalContainer'

@observer
export default class Widget extends React.Component {
  static propTypes = {
    host: PropTypes.string.isRequired,
    apiKey: PropTypes.string.isRequired,
    children: PropTypes.object.isRequired
  }

  state = {
    modalContainer: null
  }

  store = new WidgetStore({host: this.props.host, apiKey: this.props.apiKey})

  renderWidget() {
    if(this.store.unrecoverableError) {
      return (
        <div>
          <p style={styles.errorText}>An error occurred while loading this component.  Please refresh the page and try again.</p>
        </div>
      )
    }
    else {
      return (
        <div>
          { this.props.children }
        </div>
      )
    }
  }

  render() {
    const { modalContainer } = this.state

    return (
      <div className="checkcherry__widget">
        { modalContainer &&
          <Provider widgetStore={this.store} modalContainer={modalContainer}>
            { this.renderWidget() }
          </Provider>
        }
        <ModalContainer
          onLoad={el => this.setState({ modalContainer: el })}
          onUnload={() => this.setState({ modalContainer: null })}
        />
      </div>
    )
  }
}

const styles = {
  errorText: {
    textAlign: "center"
  }
}
